import { EventScoreboard, PeriodGameScore, PeriodScore } from '@frontend/sports/betting-offer/feature/model';

import { ScoreboardPairGameViewModel } from './pair-game-scoreboard.viewmodel';
import { PeriodGameFullScoreboardStats, ScoreboardStat, ScoreboardStatList } from './scoreboard-stats';

export class PeriodGameScoreboardViewModel extends ScoreboardPairGameViewModel {
    readonly stats = new PeriodGameFullScoreboardStats();

    private periodsKey = 'periods';

    constructor() {
        super();
    }

    protected override __fillFromScoreboard(scoreboard: EventScoreboard): void {
        super.__fillFromScoreboard(scoreboard);

        const score = scoreboard.getScore<PeriodGameScore>();
        if (!score) {
            return;
        }

        this.stats.isActive = scoreboard.started;
        this.stats.points = this.getPoints(score, scoreboard.started);
        this.stats.periods = this.getPeriods(scoreboard);
    }

    get score(): ScoreboardStat {
        return this.stats.values[this.scoreKey];
    }

    private getPeriods(scoreboard: EventScoreboard): ScoreboardStatList {
        const periods = new ScoreboardStatList();
        const score = scoreboard.getScore<PeriodGameScore>();

        if (!score) {
            return periods;
        }

        for (let i = 0; i < score.participant1.periods.length; i++) {
            const p1Period = score.participant1.periods[i];
            const p2Period = score.participant2.periods[i];

            periods.list.push(this.buildScoreboardStat(p1Period, p2Period));
        }

        return periods;
    }

    private buildScoreboardStat(p1Period: PeriodScore, p2Period: PeriodScore): ScoreboardStat {
        return new ScoreboardStat('', p1Period.points, p2Period.points, 0, true, '', p1Period.current ? 'highlight' : '');
    }

    private getPoints(score: PeriodGameScore, isActive: boolean): ScoreboardStat | null {
        if (!score.participant1 || !score.participant2) {
            return null;
        }

        const points = { player1: score.participant1.total.toString(), player2: score.participant2.total.toString() };

        return new ScoreboardStat(this.periodsKey, points.player1, points.player2, 1, isActive, '', 'bold');
    }
}
